"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
/**
 * Small "Have an access code?" widget for a prospect's own public homepage (2026-09-21) - a rep
 * can now just hand out the plain site URL plus a code, rather than depending on an exact deep
 * link (/presentation?key=...) being typed/pasted correctly. Same validation and storage as
 * PreviewKeyGate (GET /crm/presentation/:businessId with X-Presentation-Key, localStorage key
 * `mango_preview_key_<businessId>`), so once entered here the site's own nav (PortalContext's
 * hasPreviewKey) picks it up identically to using the deep link.
 */
function AccessCodePrompt({ apiBaseUrl, businessId, onUnlocked }) {
    const [open, setOpen] = (0, react_1.useState)(false);
    const [input, setInput] = (0, react_1.useState)('');
    const [error, setError] = (0, react_1.useState)('');
    const [checking, setChecking] = (0, react_1.useState)(false);
    const submit = async () => {
        const key = input.trim();
        if (!key)
            return;
        setChecking(true);
        setError('');
        try {
            const res = await fetch(`${apiBaseUrl}/crm/presentation/${businessId}`, {
                headers: { 'X-Presentation-Key': key },
            });
            if (!res.ok) {
                setError('That code did not work - check it and try again.');
                return;
            }
            try {
                window.localStorage.setItem(`mango_preview_key_${businessId}`, key);
            }
            catch {
                // best-effort only - PreviewKeyGate still works via the URL key param if this fails
            }
            if (onUnlocked) {
                onUnlocked();
                return;
            }
            window.location.href = '/presentation';
        }
        catch {
            setError('Network error - try again.');
        }
        finally {
            setChecking(false);
        }
    };
    if (!open) {
        return ((0, jsx_runtime_1.jsx)("div", { style: { textAlign: 'center', padding: '14px 20px' }, children: (0, jsx_runtime_1.jsx)("button", { type: "button", onClick: () => setOpen(true), style: { background: 'none', border: 'none', color: '#667eea', fontSize: 13, fontWeight: 600, cursor: 'pointer', textDecoration: 'underline' }, children: "Enter your code to see your proposal" }) }));
    }
    return ((0, jsx_runtime_1.jsxs)("div", { style: { maxWidth: 360, margin: '0 auto', padding: '14px 20px', textAlign: 'center' }, children: [(0, jsx_runtime_1.jsxs)("div", { style: { display: 'flex', gap: 8 }, children: [(0, jsx_runtime_1.jsx)("input", { type: "text", value: input, onChange: (e) => setInput(e.target.value), placeholder: "Access code", autoFocus: true, style: { flex: 1, padding: '10px 12px', border: '1px solid #ddd', borderRadius: 8, fontSize: 14 }, onKeyDown: (e) => {
                            if (e.key === 'Enter')
                                submit();
                        } }), (0, jsx_runtime_1.jsx)("button", { type: "button", onClick: submit, disabled: checking || !input.trim(), style: {
                            padding: '10px 16px',
                            borderRadius: 8,
                            border: 'none',
                            fontSize: 14,
                            fontWeight: 700,
                            background: checking || !input.trim() ? '#ccc' : '#667eea',
                            color: 'white',
                            cursor: checking || !input.trim() ? 'not-allowed' : 'pointer',
                        }, children: checking ? '…' : 'Go' })] }), error && (0, jsx_runtime_1.jsx)("div", { style: { color: '#b91c1c', fontSize: 12, marginTop: 8 }, children: error })] }));
}
exports.default = AccessCodePrompt;
